import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { TextButton } from "@gemini/ui";
export const ExpandableTextEllipsisBtn = ({ testId, buttonLabel, icon, onPress, isGradientVersion, }) => (_jsx(Box, { unsafe_className: "HideOnPrint", children: _jsx(TextButton, { testId: `${testId}.EllipsisTextBox-button`, icon: icon, iconPosition: "end", onPress: onPress, size: isGradientVersion ? "16" : "14", 
        // @ts-ignore
        marginTop: isGradientVersion && "spacing.8", children: buttonLabel }) }));
